/*
  Original Digital ART WORK by My Kim Bui
  Translated and Rewriteen by Wong Lok
*/
import { Mesh, SphereGeometry, TextureLoader } from 'three'
import * as GlowBallShader from './GlowBallShader'
import { AdditiveBlending, DoubleSide } from 'three'
// import { Noise } from 'noisejs'
import SpriteText from 'three-spritetext'
import 'requestidlecallback'

export const makeScene = async ({ o3d, clean = () => {}, camera, loop }) => {
  const matcapTexLoader = new TextureLoader()
  matcapTexLoader.setCrossOrigin('')
  // resources
  const matcapTexture = matcapTexLoader.load(require('./matcaps/matcap2.jpg'))
  const matcaptopTexture = matcapTexLoader.load(require('./matcaps/matcap-top.png'))
  const sphereGeo = new SphereGeometry(8, 32, 32);

  // const group = new Object3D()

  let reg = new Map()

  let makeFirstBall = () => {
    let material = GlowBallShader.makeMatCapCustom({ matcap: matcapTexture })
    const sphere = new Mesh(sphereGeo, material)
    sphereGeo.radius = 8
    reg.set('s1', sphereGeo)
    return sphere
  }

  let makeSecondBall = () => {
    const topmaterial = GlowBallShader.makeMatCapCustom({ matcap: matcaptopTexture });

    const topsphere = new Mesh(sphereGeo, topmaterial);
    topsphere.scale.multiplyScalar(1.21)
    loop(() => {
      topmaterial.uniforms.time.value = performance.now() * 0.0001
    })
    topsphere.material.side = DoubleSide;
    topsphere.material.blending = AdditiveBlending

    return topsphere
  }

  let makeGlowMesh = () => {
    let mat = GlowBallShader.makeMatGlowCustom({ camera })
    var glowMesh = new Mesh(sphereGeo, mat)
    glowMesh.scale.multiplyScalar(1.31)
    return glowMesh
  }

  // let k = 3;
  // let a = 0;
  // let g = 2;
  // var noise = new Noise(Math.random());
  const update = function() {
    if (reg.has('b1')) {
      reg.get('b1').rotation.y += 0.01;
    }
    if (reg.has('b2')) {
      reg.get('b2').rotation.y += 0.03;
    }
  };
  let run = true
  loop(() => {
    if (!run) {
      return
    }
    update()
  })

  let makeAuthorText = () => {
    var myText = new SpriteText('Glow Ball by My Kim Bui')
    // myText.material.blending = AdditiveBlending
    myText.material.transparent = true
    myText.material.opacity = .5
    myText.position.y = 18
    myText.textHeight = 1.0
    myText.color = 'black'
    myText.backgroundColor = 'white'
    myText.padding = '3'

    return myText
  }
  let idle = () => new Promise((resolve) => { requestAnimationFrame(resolve) })
  let setup = async () => {
    await idle()
    let firstBall0 = makeFirstBall()
    reg.set('b1', firstBall0)
    o3d.add(firstBall0)

    // await idle(100)

    let seocndBall0 = makeSecondBall()
    reg.set('b2', seocndBall0)
    o3d.add(seocndBall0)
    await idle()

    let thirdBall0 = makeGlowMesh()
    reg.set('b3', thirdBall0)
    o3d.add(thirdBall0)
    await idle()

    let spriteTextAuthor = makeAuthorText()
    o3d.add(spriteTextAuthor)

    await idle()
    // group.position.y += 25

    // o3d.add(group)

    await idle()
    clean(() => {
      run = false
      o3d.children.forEach(e => e.parent.remove(e))
    })
  }

  setup()
}